function getPageHeight() {
  return `calc(100vh - 15.8rem)`;
}

export { getPageHeight };
